import React, { useRef } from "react";
import { Formik } from "formik";
import Form from "./components/Form";
import { Modal } from "react-bootstrap";
import { useState } from "react";
import { getHolidaysDetail } from "./components/HolidaysHelper";
import { useEffect } from "react";
import Spin from "../../common/Spin";
import { API, fileUpload } from "../../../config";
import { toast } from "react-toastify";
import { AddHolidaysSchema } from "../../common/Validation";
// import moment from "moment";

const EditHolidays = ({ holidaysId, toggleHolidaysModal, showHolidays }) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const [loading, setLoading] = useState(false);
  const [holidaysData, setHolidaysData] = useState();
  const formValues = useRef();
  let existingValues = [];
  let overwrittenFields = [];

  const handleFormSubmit = async (value) => {
    const formData = new FormData();

    formData.append("name", value?.name ? value?.name : "");
    formData.append(
      "description",
      value?.description ? value?.description : ""
    );
    // formData.append("date",
    //   value?.date ? moment(value?.date, "YYYY-MM-DD").format("DD-MM-YYYY") : ""
    // );
    formData.append("date", value?.date ? value?.date : "");

    formData.append("_method", "put");

    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.HOLIDAY}/${holidaysId}`,
        formData
      );
      setLoading(false);
      if (data) {
        toast.success(data?.message);
        toggleHolidaysModal();
      }
      return data?.data;
    } catch (error) {
      setHolidaysData(value);
      setLoading(false);
      if (error?.response?.data?.errors) {
        Object.keys(error?.response?.data?.errors).forEach((key) => {
          toast.error(error?.response?.data?.errors[key][0]);
        });
        setLoading(false);
      } else {
        toast.error(error?.message);
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const data = await getHolidaysDetail(holidaysId);
        setHolidaysData(data);
        setLoading(false);
      } catch (e) {
        setHolidaysData(null);
      }
    }
    fetchData();
  }, [holidaysId]);

  return (
    <>
      <Modal
        size="lg"
        show={showHolidays}
        onHide={toggleHolidaysModal}
        dialogClassName="modal-50w larg-popup review-popup small-review"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="mb-0" closeButton>
          Holiday Details
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{
              // date: holidaysData?.date
              //   ? moment(holidaysData?.date, "DD-MM-YYYY")
              //   : "",
              date: holidaysData?.date ? holidaysData?.date : "",
              name: holidaysData?.name ? holidaysData?.name : "",
              description: holidaysData?.description
                ? holidaysData?.description
                : "",
            }}
            enableReinitialize
            innerRef={formValues}
            onSubmit={handleFormSubmit}
            validateOnBlur={true}
            validateOnChange={true}
            validationSchema={AddHolidaysSchema}
          >
            {({
              values,
              setErrors,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => {
              return (
                <>
                  {loading && <Spin />}
                  <Form
                    values={values}
                    errors={errors}
                    setErrors={setErrors}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    handleSubmit={handleSubmit}
                    setFieldValue={setFieldValue}
                    formValues={formValues}
                    overwrittenFields={overwrittenFields}
                    existingValues={existingValues}
                    toggleHolidaysModal={toggleHolidaysModal}
                    tomorrow={tomorrow}
                  />
                </>
              );
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EditHolidays;
